import React, { useMemo } from 'react';

import { keyBy } from 'lodash';
import { InfoBox, TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './InbodyIndicatorsGroupedView.module.scss';
import { InbodyIndicatorInfo } from '../../../../../../interfaces/inbodyIndicator';
import { MealPlanOnScanDayInfo } from '../../../../../../interfaces/mealPlanOnScanDayInfo';
import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { Flags } from '../../../../../../../utils-types';
import { IndicatorChart } from '../IndicatorChart/IndicatorChart';
import { INBODY_INDICATOR_GROUPS } from './InbodyIndicatorsGroupedView.settings';
import { getChartTitle } from '../../utils/getChartTitle';

type InbodyIndicatorsGroupedViewProps = {
  customerInbodyIndicators: InbodyIndicatorInfo[];
  mealPlansOnScanDay: MealPlanOnScanDayInfo[];
  customerInbodyTypeFlags: Flags<InbodyType>;
};

const InbodyIndicatorsGroupedView = ({
  customerInbodyIndicators,
  mealPlansOnScanDay,
  customerInbodyTypeFlags,
}: InbodyIndicatorsGroupedViewProps) => {
  const indicatorByKey = useMemo(
    () => keyBy(customerInbodyIndicators, 'key'),
    [customerInbodyIndicators],
  );

  return INBODY_INDICATOR_GROUPS.map((group) => (
    <InfoBox
      title={
        <TitleWithDescription
          title={group.title}
          description={group.description}
          direction="row"
          titleFont="inherit"
          withoutGap // rewrite to bigger
          className={classes.groupTitle}
        />
      }
      key={group.title}
      customContentPadding
    >
      <div className={classes.chartsGrid}>
        {group.indicatorKeys.map((key) => {
          const indicator = indicatorByKey[key];

          if (!indicator) {
            return null;
          }

          return (
            <div className={classes.chartCell} key={key}>
              <h4 className={classes.chartTitle}>
                {getChartTitle(indicator.label, indicator.measurement)}
              </h4>
              <IndicatorChart
                indicator={indicator}
                mealPlansOnScanDay={mealPlansOnScanDay}
                customerInbodyTypeFlags={customerInbodyTypeFlags}
                shortListLimit={6}
              />
            </div>
          );
        })}
      </div>
    </InfoBox>
  ));
};

export { InbodyIndicatorsGroupedView };
